// Button component styles - default variant
export const buttonStyles = 
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium " +
  "bg-primary text-primary-foreground shadow hover:bg-primary/90 " +
  "transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring " +
  "disabled:pointer-events-none disabled:opacity-50 h-9 px-4 py-2 " +
  "[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0";
